// EditColumns.js
export const getStorageValue = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
};

export const handleLocalStorageColumns = (latestColumns, storedColumns, storedTableKeys) => {
  if (!Array.isArray(latestColumns) || latestColumns.length === 0) {
    return [];
  }

  const latestColumnsById = new Map(latestColumns.map(column => [column.id, column]));
  const selectedIdsFromKeys = Array.isArray(storedTableKeys)
    ? storedTableKeys.map(column => column?.[0]).filter(Boolean)
    : [];
  const selectedIdsFromColumns = Array.isArray(storedColumns)
    ? storedColumns.filter(column => column?.selected).map(column => column.id)
    : [];
  const selectedIds = selectedIdsFromKeys.length > 0 ? selectedIdsFromKeys : selectedIdsFromColumns;
  const selectedIdSet = new Set(selectedIds);
  const storedOrder = Array.isArray(storedColumns)
    ? storedColumns.map(column => column?.id).filter(Boolean)
    : [];
  const orderedIds = [
    ...selectedIds,
    ...storedOrder.filter(id => !selectedIdSet.has(id))
  ];

  if (orderedIds.length === 0) {
    return latestColumns;
  }

  return [
    ...orderedIds
      .map(id => latestColumnsById.get(id))
      .filter(Boolean)
      .map(column => ({ ...column, selected: selectedIdSet.has(column.id) })),
    ...latestColumns
      .filter(column => !orderedIds.includes(column.id))
      .map(column => ({ ...column, selected: false }))
  ];
};

export const getSelectedTableKeys = columns => columns
  ?.filter(column => column.selected === true)
  ?.map(column => [column.dataKey, column.title]) || [];
